import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getNextRead } from "@/content/nextReads";

/**
 * "Recommended next read" — one curated, high-intent link at the end of a
 * post or spoke page. Rendered above the broader "Keep reading" grid so the
 * reader gets a single obvious next step instead of a set of choices.
 */
const NextRead = ({ slug, className = "" }: { slug: string; className?: string }) => {
  const next = getNextRead(slug);
  if (!next) return null;

  return (
    <section
      aria-labelledby="recommended-next-read"
      className={`mt-14 max-w-5xl mx-auto ${className}`}
    >
      <Link
        to={next.href}
        className="group relative block overflow-hidden rounded-2xl border border-primary/30 bg-primary/5 p-6 sm:p-8 transition-all hover:border-primary/60 hover:shadow-lg"
      >
        <div
          aria-hidden
          className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-primary/10 blur-3xl opacity-70 transition-opacity group-hover:opacity-100"
        />
        <span
          id="recommended-next-read"
          className="relative block text-[11px] font-bold uppercase tracking-[0.18em] text-primary"
        >
          Recommended next read · {next.kind}
        </span>
        <h2 className="relative mt-3 text-xl sm:text-2xl font-extrabold tracking-tight text-foreground transition-colors group-hover:text-primary">
          {next.title}
        </h2>
        <p className="relative mt-2 max-w-2xl text-sm sm:text-base leading-relaxed text-foreground/70">
          {next.reason}
        </p>
        <span className="relative mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary">
          Continue
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </span>
      </Link>
    </section>
  );
};

export default NextRead;
